import { trim } from "lodash";
import React from "react";
import clsx from "clsx";
import getColorClassByDistance from "@/domains/chat/helpers/getColorClassByDistance";
import getPlayerContent from "@/domains/chat/helpers/getPlayerContent";
import type { MessageProps } from "@/domains/chat/helpers/messageProps";
import Time from "@/domains/chat/components/chat/messages/parts/Time";

export default function ChatSpeakEmoteMessage({ message, settings }: MessageProps) {
  const { showTime } = settings;

  const segments = message.message.content.split("*").map(trim);

  return (
    <div className={clsx("w-full", getColorClassByDistance(message.player?.distance || 0))}>
      {showTime && <Time date={message.date} />} <span>{getPlayerContent(message)}</span>&nbsp;
      {segments.map((content, index) => {
        if (!content.length) {
          return null;
        }

        return (
          <React.Fragment key={`${index + index}`}>
            <span className={index % 2 === 0 ? "" : "text-[#e66dec]"}>{content}</span>
            {segments.length - 1 !== index && <span> - </span>}
          </React.Fragment>
        );
      })}
    </div>
  );
}
